<script>
  import _ from 'lodash';

  export let emoji;
</script>

{@html '&#x' + _.get(emoji, 'codes', '').split(' ').join('&#x')}